<template>
<easy-data-table
	class="data-table"
	table-class-name="customize-table"
	:headers="tableHeader"
	:items="tableRows"
	header-text-direction="left"
	:table-min-height="280"
	:table-height="tableHeight"
	:no-hover="true"
	hide-footer
>
	<template #empty-message>
		{{ emptyMessage }}
	</template>

	<template #[`header-${lightningSchema.flashFootprintKm2.key}`]="">
		<span class="text-wrap">
			<span class="text-nowrap">Площа, км<sup>2</sup></span>
			(<span class="text-nowrap">{{ eventSchema.payload.allowed.footprintRadiusKm.title }}</span>)
		</span>
	</template>

	<template #[`item-${lightningSchema.location.key}`]="item">
		{{
			item[lightningSchema.location.key] && item[lightningSchema.location.key][lightningSchema.location.type.key] == lightningSchema.location.type.allowed.point
				? `${lightningSchema.location.coordinates.lat.title}:&nbsp;${item[lightningSchema.location.key][lightningSchema.location.coordinates.key][lightningSchema.location.coordinates.lat.key]}\n
				${lightningSchema.location.coordinates.lon.title}:&nbsp;${item[lightningSchema.location.key][lightningSchema.location.coordinates.key][lightningSchema.location.coordinates.lon.key]}\n`
				: ''
		}}
	</template>

	<template #[`item-${lightningSchema.flashTimeUTC.key}`]="item">
		{{ item[lightningSchema.flashTimeUTC.key] instanceof Date ? dateTimeToString(item[lightningSchema.flashTimeUTC.key]) : '' }}
	</template>

	<template #[`item-${eventSchema.payload.allowed.distanceKm.key}`]="item">
		{{ isLightningAboveStaion(item)
			? 'над станцією'
			: flashDistance(item)?.toFixed(2)
		}}
	</template>

	<template #[`item-${lightningSchema.flashFootprintKm2.key}`]="item">
		{{ item[lightningSchema.flashFootprintKm2.key] }}
		({{ item[eventSchema.payload.allowed.footprintRadiusKm.key]?.toFixed(2) }})
	</template>
</easy-data-table>
</template>




<script>
import { watchEffect } from 'vue'
import {
	eventSchema,
	isLightningAboveStaion,
	flashDistance,
	useEvents,
} from '@/composables/events.js'
import { useLightnings, lightningSchema } from '@/composables/lightnings.js'
import {
	dateTimeToString,
	easyDataTableHeight,
	capitalizeFirstLetter,
	addSecondsToDate,
} from '@/helpers.js'


export default {
	components: {},

	props: {
		timeFrom: {
			type: Date,
			require: true,
		},
		
		timeTo: {
			type: Date,
			require: true,
		},

		stationIds: {
			type: Array,
			require: false,
			default: null,
		},

		inModal: {
			type: Boolean,
			require: false,
			default: false,
		},

		emptyMessage: {
			type: String,
			require: false,
			default: 'Блискавок не знайдено',
		},
	},

	setup(props) {
		const { allEvents: lightningEvents, setFilters } = useEvents()
		// Read lightning events
		watchEffect(() => {
			setFilters({
				fromTime: props.timeFrom,
				toTime: props.timeTo,
				eventTypes: [eventSchema.eventType.allowed.lightning.key, ],
				stationIds: props.stationIds,
			})
		})

		const {
			lightningByFlashId,
			loadLightnings,
		} = useLightnings()
		// Read lightnings
		watchEffect(() => {
			if (!lightningEvents.value || lightningEvents.value.length == 0) {
				return
			}
			
			const flashTimes = lightningEvents.value
				.map((event) => event[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key])
				.sort((a, b) => a.getTime() > b.getTime())
			const fromTime = addSecondsToDate(flashTimes.at(0), -1)
			const toTime = addSecondsToDate(flashTimes.at(-1), 1)

			loadLightnings(fromTime, toTime)
		})

		return {
			capitalizeFirstLetter,
			dateTimeToString,
			
			eventSchema,
			isLightningAboveStaion,
			flashDistance,
			lightningEvents,

			lightningSchema,
			lightningByFlashId,
		}
	},

	data() {
		return {
			tableHeader: [
				{
					text: capitalizeFirstLetter(lightningSchema.flashTimeUTC.title),
					value: lightningSchema.flashTimeUTC.key,
				},
				{
					text: capitalizeFirstLetter(lightningSchema.location.title),
					value: lightningSchema.location.key
				},
				{
					text: capitalizeFirstLetter(eventSchema.payload.allowed.distanceKm.title),
					value: eventSchema.payload.allowed.distanceKm.key,
				},
				{
					text: capitalizeFirstLetter(lightningSchema.radianceScaled.title),
					value: lightningSchema.radianceScaled.key,
				},
				{
					text: capitalizeFirstLetter(lightningSchema.flashDurationMs.title),
					value: lightningSchema.flashDurationMs.key,
				},
				{
					text: `${capitalizeFirstLetter(lightningSchema.flashFootprintKm2.title)} (${eventSchema.payload.allowed.footprintRadiusKm.title})`,
					value: lightningSchema.flashFootprintKm2.key,
				},
			],
		}
	},

	methods: {},

	computed: {
		tableRows() {
			// Set to table row event payload with joined by flashId lightning
			return this.lightningEvents.map((event) => {
				const lightning = this.lightningByFlashId.get(
					event[eventSchema.payload.key][eventSchema.payload.allowed.flashId.key]
				)

				return {
					...event[eventSchema.payload.key],
					...(lightning ?? {})
				}
				
			})
		},

		tableHeight() {
			return this.inModal
				? undefined
				: (easyDataTableHeight() - 55 - 258)
		},
	},

}
</script>




<style src="@/assets/table.css" scoped></style>
<style scoped>
</style>